export default __webpack_public_path__ + "static/media/shoes1-afterA-1024w.a4aff48a.png";